<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4 class="mb-0">เพิ่มบันทึกสำหรับ</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div>{{ selectedItem.name }} ({{ selectedItem.telephone }})</div>
      <div>
        <InputTextArea
          class="mb-4"
          type="text"
          placeholder=""
          name="text"
          rows="8"
          v-model="form.note"
        />
      </div>
      <div class="mt-2">
        <b-button
          class="btn-modal radius-btn"
          block
          variant="secondary"
          @click="$emit('confirm')"
          >ยืนยัน</b-button
        >
        <b-button
          class="btn-modal radius-btn"
          block
          variant="outline"
          @click="hide"
          >ยกเลิก</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import { mapGetters } from "vuex";

export default {
  components: {
    InputTextArea,
  },
  props: {
    form: {
      required: false,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ selectedItem: "getSelectedItem" }),
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  color: var(--primary-color);
  padding: 15px !important;
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>
